import Reveal from "../components/Reveal";

export default function PageHeader({ overline, title, italicWord, lead }) {
  const parts = italicWord ? title.split(italicWord) : [title];
  return (
    <section className="pt-40 md:pt-48 pb-16 md:pb-20 bg-[color:var(--bs-cream)]">
      <div className="mx-auto max-w-[1440px] px-6 md:px-10">
        <Reveal>
          <div className="overline text-[color:var(--bs-muted)]">{overline}</div>
        </Reveal>
        <Reveal delay={0.05}>
          <h1 className="mt-6 font-display text-5xl md:text-7xl lg:text-8xl font-light tracking-tight leading-[0.95] text-[color:var(--bs-ink)] balance">
            {italicWord ? (
              <>
                {parts[0]}
                <span className="italic text-[color:var(--bs-gold)]">{italicWord}</span>
                {parts[1]}
              </>
            ) : (
              title
            )}
          </h1>
        </Reveal>
        {lead && (
          <Reveal delay={0.15}>
            <p className="mt-8 max-w-2xl text-[color:var(--bs-muted)] leading-relaxed font-light text-base md:text-lg">
              {lead}
            </p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
